module.exports = __webpack_public_path__ + "img/co.563d3f15.svg";